import axios from 'axios';
import get from 'lodash/get';
import Swal from 'sweetalert2';
import i18n from '@/plugins/i18n';

let token = document.head.querySelector('meta[name="csrf-token"]');

if (!token) {
  console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
  window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
}

const axiosInstance = axios.create({
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'X-CLIENT-TIMEZONE': Intl.DateTimeFormat().resolvedOptions().timeZone,
    'X-CSRF-TOKEN': token.content
  }
});

const disableErrorHandler = (config = {}) => config.hasOwnProperty('disableErrorHandler') && config.disableErrorHandler === true;

const errorHandler = (error) => {
  if (disableErrorHandler(error.config) === false && error.response.status !== 404 && error.response.status !== 422) {
    Swal.fire({
      title: i18n.t('messages.whoops'),
      html: get(error, ['response', 'data', 'message'], i18n.t('messages.an_error_occurred')),
      icon: 'error',
    })
  }

  return Promise.reject({...error});
}

const successHandler = (response) => response

axiosInstance.interceptors.request.use(req => {
  req.headers['X-Socket-ID'] = window.Echo.socketId();
  return req;
});

axiosInstance.interceptors.response.use(
  response => successHandler(response),
  error => errorHandler(error)
)

export default axiosInstance;
